var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"image-container"},_vm._l((_vm.imageCount),function(index){return _c('img',{key:index,class:{ active: _vm.currentIndex === index },attrs:{"src":require(`../../assets/icons/spinner/State=${index}.svg`)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }